// CSS imported so Vite bundles it into /main.css (prod) and injects via HMR (dev).
import './src/css/styles.css'

// Delegated UI handlers (replace inline onclick=)
window.toggleMenu = function () {
    document.querySelector('.burger')?.classList.toggle('opened')
    document.querySelector('.menu')?.classList.toggle('opened')
}

window.smoothScrollTo = function (hash) {
    const target = document.querySelector(hash)
    if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

window.toggleExpand = function (button) {
    const allTexts = document.querySelectorAll('.shipping__list-block p')
    const allButtons = document.querySelectorAll('.shipping__list-block .expand-btn')
    const isExpanded = button.textContent.trim() === 'Свернуть'

    allTexts.forEach((text) => {
        if (isExpanded) text.classList.remove('expanded')
        else text.classList.add('expanded')
    })

    allButtons.forEach((btn) => {
        btn.textContent = isExpanded ? 'Подробнее' : 'Свернуть'
    })
}

// Single delegated click listener for data-action attributes.
// Survives WYSIWYG round-trip because no inline JS in the markup.
document.addEventListener('click', function (e) {
    const el = e.target.closest('[data-action]')
    if (!el) return
    const action = el.getAttribute('data-action')
    switch (action) {
        case 'toggle-menu':
            window.toggleMenu()
            break
        case 'scroll-to': {
            const target = el.getAttribute('data-target')
            if (target) window.smoothScrollTo(target)
            break
        }
        case 'scroll-to-and-close-menu': {
            const target = el.getAttribute('data-target')
            if (target) window.smoothScrollTo(target)
            window.toggleMenu()
            break
        }
        case 'toggle-expand':
            window.toggleExpand(el)
            break
    }
})

// Smooth scroll for inline anchor links (#about, #services, etc.)
document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href^="#"]')
    if (!a) return
    const hash = a.getAttribute('href')
    if (!hash || hash === '#') return
    e.preventDefault()
    window.smoothScrollTo(hash)
})

window.addEventListener('hashchange', function () {
    if (window.location.hash) window.smoothScrollTo(window.location.hash)
})

// ----- Third-party widget injectors -----
// Markers in HTML (data-arl-widget="...") are safe to round-trip through any
// visual editor; the actual third-party script is injected here at runtime.

function injectBitrix24() {
    document.querySelectorAll('[data-arl-widget="bitrix24"]').forEach((host) => {
        if (host.dataset.arlInjected === '1') return
        const formId = host.getAttribute('data-form-id')
        const loaderUrl = host.getAttribute('data-loader-url')
        if (!formId || !loaderUrl) return
        const s = document.createElement('script')
        s.setAttribute('data-b24-form', formId)
        s.setAttribute('data-skip-moving', 'true')
        s.text =
            "(function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'" +
            loaderUrl +
            "');"
        host.appendChild(s)
        host.dataset.arlInjected = '1'
    })
}

function injectJivosite() {
    document.querySelectorAll('[data-arl-widget="jivosite"]').forEach((host) => {
        if (host.dataset.arlInjected === '1') return
        const widgetId = host.getAttribute('data-widget-id')
        if (!widgetId) return
        const s = document.createElement('script')
        s.src = '//code.jivosite.com/widget/' + widgetId
        s.async = true
        document.body.appendChild(s)
        host.dataset.arlInjected = '1'
    })
}

function loadCdnScript(src) {
    if (document.querySelector('script[data-arl-cdn="' + src + '"]')) return Promise.resolve()
    return new Promise((resolve, reject) => {
        const s = document.createElement('script')
        s.src = src
        s.setAttribute('data-arl-cdn', src)
        s.onload = resolve
        s.onerror = reject
        document.head.appendChild(s)
    })
}

function loadVendorScripts() {
    return Promise.all([
        loadCdnScript('https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js'),
        loadCdnScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'),
    ])
}

// ----- Vendor-dependent initialisers -----

function initSwiper() {
    if (typeof Swiper === 'undefined') return
    if (!document.querySelector('.steps__slider')) return
    new Swiper('.steps__slider', {
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: { el: '.swiper-pagination', clickable: true },
        effect: 'fade',
        fadeEffect: { crossFade: true },
    })
}

function initFancybox() {
    if (typeof Fancybox === 'undefined') return
    Fancybox.bind('[data-fancybox="partners"]', {
        infinite: true,
        hideScrollbar: false,
        Thumbs: { autoStart: false },
        Toolbar: {
            display: {
                left: ['infobar'],
                middle: ['zoomIn', 'zoomOut', 'toggle1to1', 'rotateCCW', 'rotateCW', 'flipX', 'flipY'],
                right: ['slideshow', 'fullscreen', 'thumbs', 'close'],
            },
        },
        l10n: {
            CLOSE: 'Закрыть',
            NEXT: 'Следующее',
            PREV: 'Предыдущее',
            MODAL: 'Изображение',
            ERROR: 'Ошибка загрузки изображения',
            IMAGE_ERROR: 'Изображение не найдено',
            ELEMENT_NOT_FOUND: 'HTML элемент не найден',
            AJAX_NOT_FOUND: 'Ошибка Ajax: не найдено',
            AJAX_FORBIDDEN: 'Ошибка Ajax: запрещено',
            IFRAME_ERROR: 'Ошибка загрузки страницы',
            TOGGLE_ZOOM: 'Изменить масштаб',
            TOGGLE_THUMBS: 'Показать миниатюры',
            TOGGLE_SLIDESHOW: 'Слайдшоу',
            TOGGLE_FULLSCREEN: 'Полный экран',
            DOWNLOAD: 'Скачать',
        },
    })
}

// ----- Boot -----
function boot() {
    injectBitrix24()
    injectJivosite()
    loadVendorScripts().then(() => {
        initSwiper()
        initFancybox()
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
} else {
    boot()
}
